import React from 'react';
import styled from 'styled-components';

interface NoticeCardProps {
  title: string;
  onClick?: () => void;
  className?: string;
}

const NoticeCard: React.FC<NoticeCardProps> = ({ title, onClick, className }) => {
  return (
    <NoticeItem onClick={onClick} className={className}>
      <NoticeIconWrapper>
        <NoticeIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4.66635 12.6197C4.30818 12.6109 4.01116 12.5856 3.74186 12.5135C2.62031 12.2129 1.74428 11.3369 1.44376 10.2154C1.33247 9.80001 1.33268 9.31868 1.33299 8.64881V8.43293C1.33268 7.76306 1.33247 7.28173 1.44376 6.86637C1.74428 5.74483 2.62031 4.8688 3.74186 4.56828C4.15721 4.45698 4.63854 4.4572 5.30841 4.4575L8.20771 4.45754L13.8943 2.50278C14.0239 2.45818 14.1642 2.40992 14.2871 2.37968C14.4203 2.34689 14.6268 2.30946 14.8597 2.36632C15.1507 2.43735 15.4031 2.61754 15.5649 2.86957C15.6944 3.07133 15.7261 3.2788 15.7384 3.41549C15.7498 3.54155 15.7497 3.68989 15.7497 3.82697V13.2548C15.7497 13.3918 15.7498 13.5402 15.7384 13.6663C15.7261 13.8029 15.6944 14.0104 15.5649 14.2122C15.4031 14.4642 15.1507 14.6444 14.8597 14.7154C14.6268 14.7723 14.4203 14.7348 14.2871 14.7021C14.1641 14.6718 14.0239 14.6236 13.8942 14.579L9.08302 12.9251V15.8325C9.08302 17.0522 8.09432 18.0409 6.87469 18.0409C5.65506 18.0409 4.66635 17.0522 4.66635 15.8325V12.6197Z" fill="#448181"/>
            <path d="M18.6663 6.24915C18.6663 5.83493 18.3305 5.49915 17.9163 5.49915C17.5021 5.49915 17.1663 5.83493 17.1663 6.24915V10.8325C17.1663 11.2467 17.5021 11.5825 17.9163 11.5825C18.3305 11.5825 18.6663 11.2467 18.6663 10.8325V6.24915Z" fill="#448181"/>
          </svg>
        </NoticeIcon>
      </NoticeIconWrapper>
      <NoticeTitle>{title}</NoticeTitle>
    </NoticeItem>
  );
};

// 스타일 컴포넌트들
const NoticeItem = styled.div`
  width: 100%;
  padding: 16px 20px;
  background: #F0F7F7;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: #e8f3f3;
  }
`;

const NoticeIconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NoticeIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NoticeTitle = styled.div`
  flex: 1;
  color: #171719;
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.09px;
`;

export default NoticeCard;
